import { InjectionToken } from "@angular/core";

export const JF_SETTINGS = new InjectionToken<unknown>('JF_SETTINGS');
export const FILES_API_SETTINGS = new InjectionToken<unknown>('FILES_API_SETTINGS');
export interface JfSettings {
  apiUrl?: string;
  emailSendFrom?: string;
}
export interface FilesApiSettings {
  apiUrl: string;
}

export interface JfConfig {
  production: boolean;
  buildTarget?: string;
  appName: string;
  appIconColor: string;
  mydocmaConfig: {
    apiUrl: string;
    clientUrl: string;
    appId: string;
  };
  authConfig: {
    clientId: string;
    scope: string;
    oidc: boolean;
    issuer: string;
    redirectUri: string;
    requireHttps: boolean;
    responseType: string;
    ignoredUrls: Array<string>;
    logoutUrl: string;
    postLogoutRedirectUri: string;
  };
  supportConfig: {
    apiUrl: string,
    defaultTicket: {
      custom_fields: {
        module: string,
        nutzungsart: string
      }
    }
  };
  appContainerConfig?: {
    disableOffline: boolean,
    showBackdropOnCustomerChange: boolean
  };
  mmConfig: {
    apiUrl: string;
    maxCountFaultsEdit: number;
    maxCountFaultsNewActivity: number;
    maxCountFaultsWritings: number;
    maxCountFaultsReports: number;
  };
  webSocketConfig: {
      apiUrl: string;
      reconnectInterval: number;
      reconnectAttempts: number;
      heartbeatInterval: number;
  };
  taskConfig: {
      apiUrl: string;
  };
  exportConfig: {
    apiUrl: string;
  };
  reportingConfig: {
      apiUrl: string;
      virtualDeviceScalingOptions: number;
      rtfShareObjectsThreshold: number;
  };
  settingsConfig: {
      'apiUrl': string;
  };
  logger: {
    options: {
      logLevel: string[];
      logHttpErrors: boolean;
    };

    consoleLogger?: {
      disabled: boolean;
    };

    persistentLogger?: {
      deleteOnUsagePercentage: number;
      deleteCountOnExceeded: number;
      disabled: boolean;
    };

    exceptionlessLogger?: {
      serverUrl: string;
      apiKey: string;
      defaultTags: string[];
      disabled: boolean;
    };
  };
  pixConfig: {
    apiUrl: string;
  };
  jfConfig: JfSettings;
  filesApiConfig: FilesApiSettings;
}
